// src/hooks/useAutoLogout.js
import { useEffect, useRef } from "react";

export default function useAutoLogout(onLogout, timeout = 30 * 60 * 1000) { // default: 30  minutes
  const timerRef = useRef(null);

  const resetTimer = () => {
    if (timerRef.current) clearTimeout(timerRef.current);
    timerRef.current = setTimeout(() => {
      onLogout();
    }, timeout);
  };

  useEffect(() => {
    const activityEvents = ["mousemove", "mousedown", "keypress", "scroll", "touchstart"];

    const handleActivity = () => resetTimer();

    activityEvents.forEach(event => window.addEventListener(event, handleActivity));
    resetTimer(); // start when mounted

    return () => {
      activityEvents.forEach(event => window.removeEventListener(event, handleActivity));
      if (timerRef.current) clearTimeout(timerRef.current);
    };
  }, [onLogout, timeout]);
}
